import { FunctionComponent } from 'react'

import cx from 'classnames'
import ArrowForward from '@material-ui/icons/ArrowForward'
import InfoOutlined from '@material-ui/icons/InfoOutlined'

import TealToolTip from 'components/TealToolTip'
import TileInfoPopover from './TileInfoPopover'
import TileButton from './TileButton'
import { AccordionGroup } from 'interfaces/accordion'
import tileOverrides from 'constants/tile-overrides'

const Tile = ({
  id: sectionId,
  title,
  active,
  getUrl,
  empty,
  dull = false,
  showInactive = false,
  category,
  hideInfo,
  cxNames,
  enterIfEmpty,
  flavour,
  nodes,
  contentOverride
}:TileProps) => {
  const { borderColor, onHoverColor, iconColor } = cxNames.tile

  const append: string | null = tileOverrides.reduce((prev: string | null, val) => {
    if (val.id === sectionId) {
      return val.append
    }
    return prev
  }, null)

  return (showInactive || active) && (
    <div
      className={cx('h7 bg-white bb-thick relative', borderColor, onHoverColor)}
      style={{ opacity: empty || dull ? 0.5 : 1 }}
      data-event-category={category}
      data-event-action='Select'
      data-event-label={title}
    >
      <TileButton
        className={cx({ dull: empty || dull }, 'h-100')}
        disableRipple
        fullWidth
        disabled={empty && !enterIfEmpty}
        href={getUrl({ sectionId })}
        data-event-category={category}
        data-event-action='Select'
        data-event-label={title}
      >
        <div className='w-100'>
          <div className='black no-underline f5 absolute top5 left5 mr4 lh-title'>
            {title}
          </div>
          {append && <div className='black no-underline pl2'>{append}</div>}
        </div>
        {(!empty || enterIfEmpty) && <ArrowForward className={cx('absolute bottom4 right6', iconColor)} />}
        {!hideInfo && !empty && (
          <TileInfoPopover {...{ title, getUrl, nodes, sectionId, cxNames, contentOverride }} />
        )}
      </TileButton>
      {empty && <EmptyInfoToolTip {...{ flavour, category }} />}
    </div>
  )
}

// A bit messy but needed something quick rather than good... Feel free to do it more sensibly later
const EmptyInfoToolTip: FunctionComponent<EmptyInfoToolTip> = ({ flavour, category }) => {
  const title = (flavour === 'archive' && category === 'Q&A') ? 'No archived content' : 'No content'

  return (
    <TealToolTip {...{ title }} placement='right'>
      <span className={cx('absolute bottom4 left5')}>
        <InfoOutlined className='vm' />
      </span>
    </TealToolTip>
  )
}

interface TileProps {
  id: string;
  title: string;
  active: boolean;
  getUrl: (value: any) => string,
  empty:boolean;
  dull: boolean;
  showInactive:boolean;
  category: string;
  hideInfo: boolean;
  cxNames: {
    tile: {
      borderColor:string;
      onHoverColor:string;
      iconColor:string;
    }
  };
  enterIfEmpty: boolean;
  flavour: string;
  nodes: AccordionGroup
  contentOverride: boolean;
}

interface EmptyInfoToolTip {
  flavour: string;
  category: string;
}

export default Tile
